import { render, staticRenderFns } from "./team.vue?vue&type=template&id=1413312c"
import script from "./team.vue?vue&type=script&lang=ts"
export * from "./team.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports